import React from 'react';
import Reflux from 'reflux';
import CuesheetRowProofListStore from 'flux/stores/cuesheet/CuesheetRowProofListStore';
import UserSessionStore from 'flux/stores/UserSessionStore';
import CuesheetRowActions from 'flux/actions/cuesheet/CuesheetRowActions';
import { Icon, Avatar as UserAvatar } from '@shoflo-rundown/polymer.legacy';
import moment from 'moment-timezone';
import ConfirmActions from 'flux/actions/ConfirmActions';

export default React.createClass({
  mixins: [
    Reflux.connect(CuesheetRowProofListStore, 'proofList'),
    Reflux.connect(UserSessionStore, 'user'),
  ],

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  /**
   * Main render
   */
  render() {
    const state = this.state.proofList;

    const visible = state.get('visible'),
      title = state.get('title') || 'Item',
      list = state.get('list'),
      twentyFourHourClock = state.get('twentyFourHourClock');

    if (!visible) return null;

    return (
      <div className="proof-history-outer-list-container">
        <div
          className="proof-history-close-btn"
          onClick={() => CuesheetRowActions.hideProofHistory()}
        >
          <Icon name="close" />
        </div>
        <div className="proof-history-title-container">
          <h3>{title}</h3>
          <h4>Timestamp History</h4>
        </div>
        <div className="proof-history-list-container">
          <div className="proof-history-clear-button-container">
            <a
              className="proof-history-clear-button"
              onClick={() => this._confirmClearHistory()}
            >
              Clear Timestamp History
            </a>
          </div>
          {`Total times run: ${list.size}`}
          {list.map((proof, i) => {
            return (
              <ProofListItem
                key={`p-i-${i}`}
                {...{ twentyFourHourClock, proof }}
              />
            );
          })}
        </div>
      </div>
    );
  },

  _confirmClearHistory() {
    ConfirmActions.prompt(
      'Are you sure you want to clear the proof history for this item? This action cannot be undone.',
      () => CuesheetRowActions.clearProofHistory(),
    );
  },
});

/* eslint-disable react/prop-types */
const ProofListItem = ({ proof, twentyFourHourClock }) => {
  const mom = moment(proof.get('createdOn'));

  return (
    <div className="proof-history-item-container">
      <UserAvatar user={proof.get('createdBy').toJS()} />
      <div className="cs-proof-timestamp">
        {mom.format(
          `MM/DD/YYYY @ ${twentyFourHourClock ? 'HH:mm:ss' : 'hh:mm:ssa'}`,
        )}
      </div>
      <div className="cs-proof-note">
        <div className="cs-proof-note-readonly">{proof.get('note')}</div>
      </div>
    </div>
  );
};
/* eslint-enable react/prop-types */
